module.exports = __webpack_public_path__ + "img/prq.44b93916.svg";